import { Injectable, NgZone } from '@angular/core';
import { MatSnackBar, MatSnackBarConfig } from '@angular/material/snack-bar';

@Injectable({
  providedIn: 'root'
})
export class NotifierService {
  //#region Inputs, Outputs, ViewChilds
  //#endregion Inputs, Outputs, ViewChilds

  //#region Public Variables
  //#endregion Public Variables

  //#region Private Variables
  private defaultSnackConfig: MatSnackBarConfig;
  //#endregion Private Variables

  //#region Properties
  //#endregion Properties

  //#region Constructor and Angular Life Cycle
  constructor(
    private snackBar: MatSnackBar,
    private zone: NgZone) {
    this.defaultSnackConfig = new MatSnackBarConfig();
    this.defaultSnackConfig.verticalPosition = 'top';
    this.defaultSnackConfig.horizontalPosition = 'center';
    this.defaultSnackConfig.politeness = 'assertive';
    this.defaultSnackConfig.panelClass = 'snackbar';
  }
  //#endregion Constructor and Angular Life Cycle

  //#region Event Handlers
  //#endregion Event Handlers

  //#region Public Methods
  public CleanMessages() : void {
    this.zone.run(() => {
        this.snackBar.dismiss();
    });
  }

  public DisplayErrorMessage(message: string): void {
    this.openErrorSnackbar(message);
  }

  public DisplayFileFormatErrorMessage(file: File): void {
    const fileExt: RegExpMatchArray = file.name.match(/\.[0-9a-z]+$/i);
    const message: string = `File format ${fileExt} is not an accepted file format`;
    this.DisplayErrorMessage(message);
  }

  public DisplayMessage(message: string): void {
    this.openSnackbarMessage(message);
  }
  //#endregion Public Methods

  //#region Private Methods
  private openErrorSnackbar(message: string): void {
    this.openSnackBar(message, 'Dismiss', {
      duration: 20000,
      verticalPosition: 'top',
      horizontalPosition: 'center',
      panelClass: 'snackbar',
      politeness: 'assertive'
    });
  }

  private openSnackBar(message: string, action: string, config: MatSnackBarConfig): void {
    this.zone.run(() => {
      this.snackBar.open(message, action, config);
    });
  }

  private openSnackbarMessage(message: string, duration?: number): void {
    this.defaultSnackConfig.duration = duration ? duration : 5000;
    this.openSnackBar(message, 'Dismiss', this.defaultSnackConfig);
  }

  private openStickySnackbar(message: string): void {
    this.defaultSnackConfig.duration = 0;
    this.openSnackBar(message, 'Dismiss', this.defaultSnackConfig);
  }
  //#endregion Private Methods
}
